import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../../constants/DropdownOptions";
import { deleteDestAction, destListAction, editDestAction } from "../../../../modules/destinations/action";
import AllMainFarmSelectedDialog from "../../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../../Common/TabHeaderAndButton";
import CreateTable from "../../../CreateTable";
import ConfirmationDialog from "../../../FormElement/ConfirmationDialog";
import Loader from "../../../Loader";


class InternalDestView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        type: "Type",
        name: "Name",
        code: "Acronym",
        distance: "Distance",
        loadCostPerBushel: "Estimated Load Cost per Bushel",
        commodityName: "Default Commodity",
        varietyName: "Default Variety"
      },
      order: "desc",
      orderBy: "id"
    };
  }

  componentDidMount() {
    const { destListAction, selectedYear } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      destListAction("internal", selectedYear);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowDest &&
      this.props.rowDest !== nextProps.rowDest &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.destListAction("internal", this.props.selectedYear);
      }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
      this.props.destListAction("internal", nextProps.selectedYear);
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteDestAction(id);
  };

  editRow = id => {
    const { rowDest } = this.props;
    const requiredData = rowDest.find(destination => destination.id === id);
    this.props.editDestAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { rowDest } = this.props;
    const { headerRows, fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup",
      currentPage = "/destinations/internal";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Destinations"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="New internal destination"
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}
        />
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div>
              {fetchingComplete ? (
                <CreateTable
                  order={order}
                  orderBy={orderBy}
                  headerRows={headerRows}
                  rowData={rowDest}
                  delete={this.deleteRow}
                  location={`${prevPath}${currentPage}/edit`}
                  edit={this.editRow}
                  onRequestSort={this.handleRequestSort}
                />
              ) : (
                <Loader />
              )}
            </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowDest: state.destReducer.destList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { destListAction, deleteDestAction, editDestAction },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDestView);



// WEBPACK FOOTER //
// ./src/components/private/Destinations/InternalDest/InternalDestView.js